// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__IkFzJ","item":"PaymentsMobile_item__YZoN5","label":"PaymentsMobile_label__34yFq","amount":"PaymentsMobile_amount__390EJ"};